import { atom } from 'jotai';

/**
 * When (`Date.now()`) a 403 CONSULTANT_NOT_ACTIVE_PARTNER asked for the
 * "consultant profile not active" notice; null when none is pending. Lives in a
 * store (not in MainLayout state) so the request survives ProtectedRoute
 * swapping the layout out after the memberships refetch.
 *
 * It is a request, not the open state: the dialog opens only once a
 * memberships response newer than the request says the full-screen
 * `ConsultantProfileInactiveScreen` will not take over (see
 * `ConsultantNotActivePartnerDialog`).
 */
export const consultantAccessNoticeRequestedAtAtom = atom<number | null>(null);
